<template>
  <div class="user-edit" style="height: 100%">
    <van-form class="user-edit-form" v-if="form" ref="form" label-width="100px" @submit="save()">
      <div
        style="
          position: relative;
          margin: 0.55rem;
          background-color: #ffffff;
          padding:0 0.41rem 0.79rem 0.41rem;
        "
      >
        <div class="text-center" style="position: relative;">
          <div
            v-if="form.officialPhoto2"
            class="inline-block official-photo"
          >
            <div :class="{img: true, 'img-filter': form.officialAuthStatus === 3 ? true : false}"
              @click="
                showOverlay = true;
                showOverlayUrl = form.officialPhoto2;
              "
              :style="{
                backgroundImage: `url('${form.officialPhoto2}')`
              }">
            </div>
            <div class="text-center tips tips3" v-if="form.officialAuthStatus === 3">
              <span>审核中</span>
            </div>
            <div v-else class="text-center tips" @click="selectOfficialPhoto">
              <span>修改照片</span>
            </div>
          </div>
          <div v-else class="inline-block official-photo">
            <div class="img"
              :style="{
                backgroundImage: `url(${userEmptyImg})`
              }">
            </div>
            <div class="text-center tips" @click="selectOfficialPhoto">
              <span>上传照片</span> 
            </div>
          </div>
        </div>
        <div class="auth-success-tip" v-if="form.officialAuthStatus === 1">
          <div class="success-tip"><van-icon name="success" color="#00D885" style="vertical-align: middle;"/>认证通过</div>
        </div>
        <div class="auth-tip auth-cross-tip" v-if="form.officialAuthStatus === 2">
          <div style="text-align: center"><van-icon name="cross" style="vertical-align: middle;"/>认证失败</div>
          <div v-if="form.unpassReason">原因：{{form.unpassReason}}</div>
        </div>
        <div
          style="
            background-color: #FDF9EE;
            color: #B5782D;
            padding: 0.25rem 0.43rem;
            font-size: 0.3rem;
            border: solid 1px #F2E8DC;
            margin-top: 0.43rem;
          "
        >
          注：请上传考生近期2寸证件照，提交的照片须为100K以上照相馆拍摄的2寸原版彩色证件照，该证件照将被用做校验考生身份和证书制作之用
        </div>
        <van-field
          :value="form.phoneNumber || form.email || form.examineeIdNo"
          required
          readonly
          label="账户信息"
          placeholder="未填写"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
        <!--  :readonly="form.authStatus == 1" -->
        <van-field
          v-model="form.examineeName"
          required
          label="考生姓名"
          :maxlength="30"
          :readonly="form.authStatus == 1"
          :rules="[$validate.string(30)]"
          @change="toPinyin"
          placeholder="未填写"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
        <van-field
          v-model="form.examineeNameSpell"
          required
          label="姓名拼音"
          :readonly="
            form.authStatus == 1 && !Tool.isNull(oldInfo.examineeNameSpell)
          "
          :maxlength="200"
          placeholder="未填写"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
        <select-pick
          v-model="form.examineeSex"
          required
          :columns="Tool.map2arr($enums.sex)"
          :disabled="form.authStatus == 1 && !Tool.isNull(oldInfo.examineeSex)"
          label="性别"
          :rules="[$validate.select()]"
          labelCol="label"
          valueCol="value"
          @change="onSelectChange($event, 'examineeSex')"
        ></select-pick>
        <select-pick
          v-model="form.countryCode"
          required
          :columns="countryList"
          :disabled="form.authStatus == 1"
          label="国家/地区"
          :rules="[$validate.select()]"
          labelCol="zh"
          valueCol="code"
          @change="onSelectChange($event, 'countryCode')"
        ></select-pick>
        <select-pick
          v-model="form.nationalityCode"
          required
          :columns="nationalityList"
          :disabled="form.authStatus == 1"
          label="民族"
          :rules="[$validate.select()]"
          labelCol="desc"
          valueCol="code"
          @change="onSelectChange($event, 'nationalityCode')"
        ></select-pick>
        <date-pick
          v-model="form.birthday"
          required
          label="出生日期"
          :disabled="form.authStatus == 1 && !Tool.isNull(oldInfo.birthday)"
          :rules="[$validate.select()]"
        ></date-pick>
        <select-pick
          v-model="form.idType"
          required
          :columns="Tool.map2arr($enums.idType)"
          :disabled="form.authStatus == 1"
          label="证件类型"
          :rules="[$validate.select()]"
          labelCol="label"
          valueCol="value"
          @change="onSelectChange($event, 'idType')"
        ></select-pick>
        <van-field
          v-model="form.examineeIdNo"
          required
          :readonly="form.authStatus == 1"
          label="证件号码"
          :maxlength="30"
          placeholder="未填写"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
        <select-pick
          v-model="form.specialtyId"
          required
          :columns="specialtyList"
          label="报考专业"
          :rules="[$validate.select()]"
          labelCol="name"
          valueCol="id"
          parentCol="parentId"
          @change="onSelectChange($event, 'specialtyId')"
        ></select-pick>
        <select-pick
          v-model="form.gradeId"
          required
          :columns="gradeList"
          label="报考等级"
          :rules="[$validate.select()]"
          labelCol="gradeName"
          valueCol="gradeId"
          @change="onSelectChange($event, 'gradeId')"
        ></select-pick>
        <!-- <select-pick
          v-show="false"
          v-model="form.subjectGroupId"
          :columns="subjectGroupList"
          label="教材"
          :rules="[$validate.select()]"
          labelCol="subjectGroupName"
          valueCol="subjectGroupId"
          @change="onSelectChange($event, 'subjectGroupId')"
        ></select-pick> -->
        <select-pick
          v-model="form.agentAreaId"
          required
          :columns="areaList"
          label="所在地区"
          :rules="[$validate.select()]"
          labelCol="areaName"
          valueCol="areaId"
          parentCol="parentId"
          @change="onSelectChange($event, 'agentAreaId')"
        ></select-pick>
        <select-pick
          v-model="form.gradeAgentId"
          required
          :columns="agentList"
          label="报名点"
          :rules="[$validate.select()]"
          labelCol="agentName"
          valueCol="gradeAgentId"
          noDataContent="该地区无考点"
          @change="onSelectChange($event, 'gradeAgentId')"
        ></select-pick>
      </div>
      <div
        style="
          margin: 0.55rem;
          background-color: #ffffff;
          padding: 0.42rem 0.42rem;
        "
      >
        <div style="color: #212B36; font-size: 0.48rem; font-weight: bold">
          收件人信息
        </div>
        <van-field
          v-model="form.receiverName"
          required
          label="收件人"
          :maxlength="30"
          :rules="[$validate.string(30)]"
          placeholder="未填写"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
        <van-field
          v-model="form.receiverPhone"
          required
          label="联系手机"
          :rules="[$validate.mobile()]"
          :maxlength="11"
          placeholder="未填写"
          type="tel"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
        <select-pick
          v-model="form.receiverAddressInfo2"
          required
          :columns="areaList"
          label="所在地区"
          :rules="[$validate.select()]"
          labelCol="areaName"
          valueCol="areaId"
        ></select-pick>
        <van-field
          v-model="form.receiverAddressDetail"
          required
          label="详细地址"
          :rules="[$validate.string(30)]"
          :maxlength="30"
          placeholder="未填写"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
      </div>
      <div
        style="
          margin: 0.55rem;
          background-color: #ffffff;
          padding: 0.42rem 0.42rem;
        "
      >
        <div style="color: #212B36; font-size: 0.48rem; font-weight: bold">
          指导老师信息
        </div>
        <van-field
          v-model="form.teacherName"
          required
          label="指导老师"
          :maxlength="30"
          :rules="[$validate.string(30)]"
          placeholder="未填写"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
        <van-field
          v-model="form.teacherPhone"
          required
          label="老师手机"
          :rules="[$validate.mobile()]"
          :maxlength="11"
          placeholder="未填写"
          type="tel"
          :border="false"
          style="border-bottom: 0.5px solid #ebedf0; margin-top: 0.1rem"
        ></van-field>
      </div>
      <div
        style="
          margin: 0.55rem;
          background-color: #ffffff;
          padding: 0.42rem 0.42rem;
        "
      >
        <div style="color: #212B36; font-size: 0.48rem; font-weight: bold">
          考级证书图片
        </div>
        <div style="color: #D12134; font-size: 0.27rem; margin-top: 0.1rem">
          * 请上传上一考级证书图片，报考6级及以上必须上传证书照片
        </div>
        <div class="text-center" style="padding-top: 0.79rem">
          <van-uploader
            accept="image/*"
            max-count="1"
            :after-read="uploadOSS1"
            :max-size="5 * 1024 * 1024"
            @oversize="onOversize"
            class="inline-block"
          >
            <div v-if="form.certificateUrl2">
              <div 
                class="certificate-img"
                :style="{
                width: '8.08rem',
                height: '5.33rem',
                background: `url('${form.certificateUrl2}') no-repeat center`
              }">

              </div>
              <!-- <img
                :src="form.certificateUrl2"
                alt=""
                style="width: 8.08rem; height: 5.33rem"
              /> -->
            </div>
            <div
              v-else
              style="
                background: rgba(201, 204, 214, 0.06);
                border: 1px dashed #D3D3D3;
                width: 8.08rem;
                height: 5.33rem;
                border-radius: 0.1067rem;
              "
            >
              <img
                src="../../static/images/examSign/icon_zssc.png"
                alt=""
                style="width: 0.77rem; margin-top: 2.03rem"
              />
              <div style="color: #373D52; margin-top: 0.22rem">
                上传证书照片
              </div>
            </div>
          </van-uploader>
        </div>
      </div>
    </van-form>
    <van-overlay :show="showOverlay" @click="showOverlay = false" :z-index="10">
      <div
        style="
          display: table-cell;
          vertical-align: middle;
          width: 100vw;
          height: 100vh;
        "
      >
        <img :src="showOverlayUrl" alt="" style="width: 100%"/>
      </div>
    </van-overlay>
    <div style="height: 1.5rem"></div>
    <van-button
      :disabled="
        !(
          !Tool.isNull(form) &&
          !Tool.isNull(form.examineeName) &&
          !Tool.isNull(form.officialPhoto) &&
          !Tool.isNull(form.examineeNameSpell) &&
          !Tool.isNull(form.examineeSex) &&
          !Tool.isNull(form.countryCode) &&
          !Tool.isNull(form.nationalityCode) &&
          !Tool.isNull(form.birthday) &&
          !Tool.isNull(form.idType) &&
          !Tool.isNull(form.examineeIdNo) &&
          !!form.specialtyId &&
          !!form.gradeId &&
          !!form.agentAreaId &&
          !!form.gradeAgentId &&
          !Tool.isNull(form.receiverName) &&
          !Tool.isNull(form.receiverPhone) &&
          !!form.receiverAddressInfo2 &&
          !Tool.isNull(form.receiverAddressDetail) &&
          !Tool.isNull(form.teacherName) &&
          !Tool.isNull(form.teacherPhone)
        )
      "
      @click="save"
      :class="
        !(
          !Tool.isNull(form) &&
          !Tool.isNull(form.examineeName) &&
          !Tool.isNull(form.officialPhoto) &&
          !Tool.isNull(form.examineeNameSpell) &&
          !Tool.isNull(form.examineeSex) &&
          !Tool.isNull(form.countryCode) &&
          !Tool.isNull(form.nationalityCode) &&
          !Tool.isNull(form.birthday) &&
          !Tool.isNull(form.idType) &&
          !Tool.isNull(form.examineeIdNo) &&
          !!form.specialtyId &&
          !!form.gradeId &&
          !!form.agentAreaId &&
          !!form.gradeAgentId &&
          !Tool.isNull(form.receiverName) &&
          !Tool.isNull(form.receiverPhone) &&
          !!form.receiverAddressInfo2 &&
          !Tool.isNull(form.receiverAddressDetail) &&
          !Tool.isNull(form.teacherName) &&
          !Tool.isNull(form.teacherPhone)
        )
          ? 'disabled'
          : ''
      "
      type="info"
      style="
        width: calc(100% - 1.1rem);
        z-index: 1;
        margin: 0 0.55rem;
        bottom: 0.5rem;
        position: fixed;
        border: none;
        opacity: 1;
      "
    >
      点击提交
    </van-button>
  </div>
</template>
<script>
import {
  Form,
  Picker,
  Popup,
  Button,
  Icon,
  Field,
  Checkbox,
  CheckboxGroup,
  Toast,
  Uploader,
  Overlay,
  Dialog,
} from "vant";
import SelectPick from "../components/select-pick";
import DatePick from "../components/date-pick";
import Cropper from "../components/cropper";
// import pinyin from 'pinyin'
import userEmptyImg from '../../static/images/examSign/user_empty.png'
import MyCropper from "../components/my-cropper";

export default {
  components: {
    [Form.name]: Form,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    [Overlay.name]: Overlay,
    [Cropper.name]: Cropper,
    [SelectPick.name]: SelectPick,
    [DatePick.name]: DatePick,
    [MyCropper.name]: MyCropper
  },
  data () {
    return {
      form: null,
      oldInfo: null,
      countryList: [],
      specialtyList: [],
      gradeList: [],
      huBeiList: [],
      areaList: [],
      allAreaList: [],
      nationalityList: [],
      agentList: [],
      subjectGroupList: [],
      showOverlay: false,
      showOverlayUrl: "",
      userEmptyImg
    };
  },
  async created () {
    await this.initForm();
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    clickRightIcon (name) {

    },
    encryName (str, start, end, reStr) {
      let startStr = str.substr(0, start)
      let midStr = ''
      let endStr = ''
      if (end <= str.length && end > start) {
        var seatFill = []
        seatFill.length = end - start + 1
        let midStr = seatFill.fill(reStr)
      }
      endStr = str.substr(end, start) 
    },
    async initForm () {
      try {
        this.nationalityList = await this.$HTTP.ApiEnroll.getNationalityList();
        this.specialtyList = await this.$HTTP.ApiEnroll.getSpecialtyList(
          this.$route.query.batchId
        );
        let info = await this.$HTTP.ApiEnroll.getUserInfo();
        let lastEnrollInfo = await this.$HTTP.ApiEnroll.getLastEnrollInfo();
        let areaList = await this.$HTTP.ApiEnroll.getAreaList();
        this.allAreaList = JSON.parse(JSON.stringify(areaList));
        this.countryList = [
          { zh: "中国大陆", code: "000001" },
          { zh: "国际", code: "000000" },
          { zh: "港澳台侨", code: "999999" },
        ];
        this.areaList = this.Tool.toTree(
          areaList,
          "areaId",
          "parentId",
          "",
          "children"
        );
        console.log('areaList:',this.areaList)
        // 过滤只有湖北省
        // for (let i in this.areaList) {
        //   let area = this.areaList[i];
        //   if (area.areaName === "湖北省") {
        //     let huBeiList = JSON.parse(JSON.stringify([area]));
        //     this.Tool.walkTree(huBeiList, (node) => {
        //       if (node.areaType === 2) {
        //         delete node.children;
        //       }
        //     });
        //     this.huBeiList = huBeiList;
        //   }
        // }
        for (let i in this.areaList) {
          let area = this.areaList[i];
          if (this.Tool.isNull(area.children)) {
            area.children = [JSON.parse(JSON.stringify(area))];
          }
        }
        if (lastEnrollInfo) {
          info.receiverName = lastEnrollInfo.receiverName;
          info.receiverPhone = lastEnrollInfo.receiverPhone;
          info.receiverAddressInfo = lastEnrollInfo.receiverAddressInfo;
          info.receiverAddressDetail = lastEnrollInfo.receiverAddressDetail;
          info.teacherName = lastEnrollInfo.teacherName;
          info.teacherPhone = lastEnrollInfo.teacherPhone;
          info.certificateUrl = lastEnrollInfo.certificateUrl;
        }
        // 音协默认选择地区 info.agentAreaId = this.$route.query.areaId;
        let tmpInfo = this.Tool.getStorage("user-edit-info");
        if (!this.Tool.isNull(tmpInfo) && tmpInfo.batchId === info.batchId) {
          info.officialPhoto = tmpInfo.officialPhoto;
          info.examineeName = tmpInfo.examineeName;
          info.examineeNameSpell = tmpInfo.examineeNameSpell;
          info.examineeSex = tmpInfo.examineeSex;
          info.countryCode = tmpInfo.countryCode;
          info.nationalityCode = tmpInfo.nationalityCode;
          info.birthday = tmpInfo.birthday;
          info.idType = tmpInfo.idType;
          info.examineeIdNo = tmpInfo.examineeIdNo;
          info.receiverName = tmpInfo.receiverName;
          info.receiverPhone = tmpInfo.receiverPhone;
          info.receiverAddressInfo2 = tmpInfo.receiverAddressInfo2;
          info.receiverAddressDetail = tmpInfo.receiverAddressDetail;
          info.teacherName = tmpInfo.teacherName;
          info.teacherPhone = tmpInfo.teacherPhone;
          info.certificateUrl = tmpInfo.certificateUrl;
          info.agentAreaId = tmpInfo.agentAreaId;
        }
        if (!info.receiverAddressInfo2 && info.receiverAddressInfo) {
          info.receiverAddressInfo2 = this.getAreaId(info.receiverAddressInfo);
        }
        info.birthday = info.birthday ? info.birthday.replace(/\./g, "-") : "";
        info.officialPhoto2 = await this.$HTTP.ApiOss.signatureUrl(
          info.officialPhoto,
          "ID-photo"
        );
        delete info.certificateUrl;
        info.certificateUrl2 = await this.$HTTP.ApiOss.signatureUrl(
          info.certificateUrl,
          "exam-data"
        );
        info.phoneNumberEncry = true
        info.nameEncry = true
        info.idEncry = true
        // console.log('ffff:', info)
        this.form = info;
        if (this.Tool.isNull(this.form.examineeNameSpell)) {
          await this.toPinyin();
        }
        this.oldInfo = JSON.parse(JSON.stringify(info));
      } catch (e) {
        this.Tool.doError(e);
      }
    },
    async uploadOSS (e) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '图片上传中...'
      });
      try {
        const filePath = await this.$HTTP.ApiOss.uploadOSS(e.file, "officialPhoto", ".png,.jpg", "ID-photo");
        const convertOfficialPhoto = await this.$HTTP.ApiUser.convertOfficialPhotoPOST(filePath);
        // console.log('xxxxx:', filePath)
        console.log('convertOfficialPhoto:',filePath,convertOfficialPhoto.data)
        const url = await this.$HTTP.ApiOss.signatureUrl(convertOfficialPhoto.data, "ID-photo");
        if (this.form.newestSuccessPhoto) {
          // newestSuccessPhoto
          console.log(this.form.newestSuccessPhoto, "1111");
          const userFace = {
            sourceImage: this.form.officialPhoto,
            targetImage: filePath,
          };
          console.log(userFace)
          const compareImage = await this.$HTTP.ApiCommon.POSTFaceCompare(userFace);
          if (!compareImage.data || compareImage.data === 'false' || compareImage.data === false || compareImage.data === null) {
            Toast("人脸验证失败，请上传清晰的本人证件照");
            return false;
          }
        }
        
        this.form.officialPhoto = filePath;
        this.form.officialPhoto2 = url;
        Toast.clear()
        this.$forceUpdate();
      } catch (e) {
        this.Tool.doError(e);
        Toast.clear()
      }
    },
    // 选择个人图像
    async selectOfficialPhoto () {
      try {
        let filePhoto = await this.$AppMethod.showPictureSelector()
        let { data: filePath} = await this.$HTTP.ApiUser.convertOfficialPhotoPOST(filePhoto);
        const url = await this.$HTTP.ApiOss.signatureUrl(filePath, "ID-photo");
        if (this.form.newestSuccessPhoto) {
          // newestSuccessPhoto
          const userFace = {
            sourceImage: this.form.officialPhoto,
            targetImage: filePath,
          };
          console.log(userFace)
          const compareImage = await this.$HTTP.ApiCommon.POSTFaceCompare(userFace);
          if (!compareImage.data || compareImage.data === 'false' || compareImage.data === false || compareImage.data === null) {
            Toast("人脸验证失败，请上传清晰的本人证件照");
            return false;
          } else {
            await this.$HTTP.ApiUser.changeOfficialPhotoPUT(filePath)
            Toast("证件照更换成功！")
          }
        } else {
          if (this.form.authStatus === 1) {
            await this.$HTTP.ApiUser.changeOfficialPhotoPUT(filePath)
            Toast("证件照更换成功！")
          }
        }
        this.$set(this.form, 'officialAuthStatus', 3)
        this.form.officialPhoto = filePath;
        this.form.officialPhoto2 = url;
        this.$forceUpdate();
      } catch (e) {
        this.Tool.doError(e);
      }
    },
    async uploadOSS1 (e) {
      try {
        const filePath = await this.$HTTP.ApiOss.uploadOSS(e.file, "certificate", ".png,.jpg", "exam-data");
        const url = await this.$HTTP.ApiOss.signatureUrl(filePath, "exam-data");
        this.form.certificateUrl = filePath;
        this.form.certificateUrl2 = url;
        this.$forceUpdate();
      } catch (e) {
        this.Tool.doError(e);
      }
    },
    async toPinyin () {
      if (!this.Tool.isNull(this.form.examineeName)) {
        let examineeNameSpell = await this.$HTTP.ApiCommon.toPinyinPOST(
          this.form.examineeName
        );
        this.form.examineeNameSpell = examineeNameSpell.data;
      } else {
        this.form.examineeNameSpell = null;
      }
    },
    onOversize () {
      Toast("图片大小超过限制");
    },
    async onSelectChange ($event, field) {
      try {
        this.form[field] = $event;
        if (field === "specialtyId") {
          this.form.gradeId = null;
          this.gradeList = await this.$HTTP.ApiEnroll.getGradeList(
            this.form.specialtyId
          );
          this.form.subjectGroupId = null;
          this.subjectGroupList = [];
          this.form.gradeAgentId = null;
          this.agentList = [];
        } else if (field === "gradeId") {
          let checkEnroll = await this.$HTTP.ApiEnroll.checkEnroll(
            this.form.gradeId
          );
          if (checkEnroll && Number(checkEnroll.isImport) === 0) {
            let orderRes = await this.$HTTP.ApiEnroll.getOrderRes(
              checkEnroll.orderId
            );
            if (Number(orderRes.tradeState) === 0) {
              this.$AppMethod.zgLog(`订单信息：${JSON.stringify(orderRes)}`);
              this.$AppMethod.launchOrderPayPage(JSON.stringify(orderRes));
              return false;
            } else if (Number(orderRes.tradeState) === 2) {
              Toast("您已经报名了该等级！");
              this.form.gradeId = null;
              return false;
            }
          } else if (checkEnroll) {
            Toast("您已经报名了该等级！");
            this.form.gradeId = null;
            return false;
          }
          for (let i in this.gradeList) {
            let gradeInfo = this.gradeList[i];
            if (this.form.gradeId === gradeInfo.gradeId) {
              this.form.gradeInfo = gradeInfo;
            }
          }
          this.form.subjectGroupId = null;
          this.subjectGroupList = await this.$HTTP.ApiEnroll.getSubjectGroupList(
            this.form.gradeId
          );
          // 给到
          if (this.subjectGroupList && this.subjectGroupList.length) {
            this.form.subjectGroupId = this.subjectGroupList[0].subjectGroupId
          }
          if (this.form.agentAreaId) {
            this.form.gradeAgentId = null;
            this.agentList = await this.$HTTP.ApiEnroll.getAgentList(
              this.form.gradeId,
              this.form.agentAreaId
            );
            if (this.Tool.isNull(this.agentList)) {
              Toast("该地区无考点");
            }
          } else {
            this.form.agentAreaId = null;
            this.form.gradeAgentId = null;
            this.agentList = [];
          }
        } else if (field === "subjectGroupId") {
          console.log("this.form.subjectGroupId", this.form.subjectGroupId);
        } else if (field === "agentAreaId") {
          this.form.gradeAgentId = null;
          if (this.form.gradeId) {
            this.agentList = await this.$HTTP.ApiEnroll.getAgentList(
              this.form.gradeId,
              this.form.agentAreaId
            );
            if (this.Tool.isNull(this.agentList)) {
              Toast("该地区无考点");
            }
          }
        } else if (field === "gradeAgentId") {
          for (let i in this.agentList) {
            let agent = this.agentList[i];
            if (agent.gradeAgentId === this.form.gradeAgentId) {
              let currentTime = await this.$HTTP.ApiEnroll.getCurrentTime();
              if (
                this.$moment(currentTime.currentTime).isSameOrAfter(
                  this.$moment(agent.enrollStartTime)
                ) &&
                this.$moment(currentTime.currentTime).isSameOrBefore(
                  this.$moment(agent.enrollEndTime)
                )
              ) {
                console.log("该报名点可以报名");
              } else {
                this.$forceUpdate();
                Toast(`该报名点暂未开放报名`);
                this.form.gradeAgentId = null;
              }
            }
          }
        }
        this.$forceUpdate();
      } catch (e) {
        this.Tool.doError(e);
      }
    },
    getAreaName (areaId, areaList = []) {
      let arr = [];
      for (let i in areaList) {
        let area = areaList[i];
        if (area.areaId === areaId) {
          arr.push(area.areaName);
          if (area.parentId && area.parentId !== area.areaId) {
            for (let j in areaList) {
              let parent = areaList[j];
              if (parent.areaId === area.parentId) {
                arr.push(parent.areaName);
              }
            }
          }
        }
      }
      return arr.reverse().join("/");
    },
    getAreaId (areaName) {
      let arr = areaName.split("/");
      let name = arr[arr.length - 1];
      let areaId = null;
      this.Tool.walkTree(this.areaList, (node) => {
        if (name === node.areaName) {
          areaId = node.areaId;
        }
      });
      return areaId;
    },
    async save () {
      try {
        let isOK = await this.Tool.checkForm(this.$refs["form"]);
        if (isOK) {
          let info = JSON.parse(JSON.stringify(this.form));
          for (let i in this.countryList) {
            let country = this.countryList[i];
            if (country.code === info.countryCode) {
              info.country = country.zh;
            }
          }
          for (let i in this.nationalityList) {
            let nationality = this.nationalityList[i];
            if (nationality.code === info.nationalityCode) {
              info.nationality = nationality.desc;
            }
          }
          info.birthday = this.$moment(info.birthday).format("YYYY.MM.DD");
          info.receiverAddressInfo = this.getAreaName(
            info.receiverAddressInfo2,
            this.allAreaList
          );
          Dialog.confirm({
            title: "提示",
            message: "请确保填写信息无误，点击确定后不可修改",
            confirmButtonColor: "#aa0405",
          })
            .then(async () => {
              try {
                if (Number(this.form.authStatus) === 0) {
                  await this.$HTTP.ApiEnroll.checkAuth(info);
                  // await this.$HTTP.ApiUser.changeOfficialPhotoPUT(
                  //   this.form.officialPhoto
                  // );
                }

                if (Number(info.gradeInfo.chooseQuestionStep) === 0) {
                  this.Tool.setStorage("user-edit-info", info);
                  this.$router.push({
                    path: "./exam-question-edit",
                    query: this.$route.query,
                  });
                } else {
                  try {
                    let orderData = await this.$HTTP.ApiEnroll.commitExamEnroll(
                      info
                    );
                    Toast("保存成功");
                    this.$AppMethod.zgLog(
                      `订单信息：${JSON.stringify(orderData)}`
                    );
                    this.$AppMethod.refreshNativeUserinfo();
                    this.$AppMethod.launchOrderPayPage(JSON.stringify(orderData));
                  } catch (e) {
                    // Toast({
                    //   message: e,
                    //   duration: 3000
                    // });
                    this.Tool.doError(e);
                  }
                }
              } catch (e) {
                
                this.Tool.doError(e);
              }
            })
            .catch((e) => {
              this.Tool.doError(e);
            });
        }
      } catch (e) {
        this.Tool.doError(e);
      }
    },
  },
};
</script>
<style>
  .user-edit {
    margin-top: 66px;
  }
  
  .user-edit .disabled {
    background-color: #E6E1DF;
  }
  
  .user-edit .official-photo {
    position: relative;
    width: 96px;
    height: 57.5px;
    font-size: 0;
  }
  .user-edit .official-photo .img{
    position: absolute;
    top: -38.5px;
    left: 0;
    width: 96px;
    height: 96px;
    background-color: #F5F4F4;
    border-radius: 4px;
    box-sizing: border-box;
    border: 2px solid #77573A;
    background-size: cover !important;
    background-repeat: no-repeat;
    background-position: top;
  }
  
  .img-filter {
    -webkit-filter: blur(2px); /* Chrome, Safari, Opera */
    filter: blur(2px);
  }

  .user-edit .official-photo .tips {
    position: absolute;
    bottom: 0;
    width: 96px;
    height: 20px;
    background: #000000;
    opacity: 0.5;
    border-radius: 0px 0px 4px 4px;
  }

  .user-edit .official-photo .tips3 {
    height: 96px;
  }

  .user-edit .official-photo .tips span{
    position: relative;
    height: 17.5px;
    font-size: 12px;
    font-family: Source Han Serif CN;
    font-weight: 400;
    line-height: 17.5px;
    color: #FFFFFF;
    opacity: 1;
  }

  .user-edit .official-photo .tips.tips3 span{
    top: 39.25px;
  }

  .user-edit .user-cropper {
    bottom: 0;
  }

  .user-edit .certificate-img {
    background-size: contain !important;
  }

  .user-edit .auth-tip {
    background-color: #FDF9EE;
    color: #B5782D;
    padding: 0.25rem 0.43rem;
    font-size: 0.3rem;
    border: solid 1px #F2E8DC;
    margin-top: 0.43rem;
  }

  .user-edit .auth-cross-tip {
    margin-top: 0;
    background: #FFF4F4;
    border: 2rpx solid #FF6262;
    color: #FF6262;
  }

  .user-edit .auth-success-tip {
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }

  .user-edit .success-tip {
    display: inline-block;
    width: 96px;
    background: #F0FFF9;
    border: 1px solid #00D885;
    border-radius: 50px;
    font-size: 12px;
    color: #00D885;
  }
</style>
